// Overview: This file contains 4 slide decks associated with Software Engineering (SE) module 1 / sprint 1. Each 
// slidedeck is exported via the se_1_slidedeckTTR structure.

import { agendaSlide, basicSlide, orderedListSlide, tPrework, tRecap, tPreworkWithLogo, basicSlideWithLogo } from './SLSprint00'
import { makeSlideDeck, tLab, tReviewDemoSchedule } from './SL00000Sprint00'
import { tQuizExpectations, tQuiz } from './SLSprint00'
import { /* xyz_n_4of4_PAaA,*/ xyz_n_4of4 } from './SL44000Sprint01TTR'

import { breakoutStandard } from './SLSprint00'
import { list44000Sprint01 } from '../ActivityLists/AL44000Sprint01'
import { list44000Sprint02 } from '../ActivityLists/AL44000Sprint02'

import { checklistAnnouncementsPreworkAndAgenda } from './SL00000Sprint00'
import { submissionPercentage } from './SLSprint00'
import { completeDeck } from './SL00000Sprint00'
import { sprintDemos, sprintDemosIntro, demoAssignment } from './SLSprint00'
// import { tUnderConstruction } from './SL00000Sprint00'
// import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

// Software Engineering (SE) sprint 2 global values.
const sprint = 2
const activityList = () => { return list44000Sprint02(sprint) }
const activityListPrevious = () => { return list44000Sprint01(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Shared slides across multiple sessions.
export const xyz_2_1of4 = (pAaA, pAaANext, saals) => {
	const prework = () => { return tPreworkWithLogo('Prework For Today', pAaA.prework, saals.sprint-1, saals.activityListPrevious) }
	const announcements =  () => { return basicSlideWithLogo( 'Announcements', ['Let’s stay focused on sprint planning today']) }
	const agenda = () => { return agendaSlide(pAaA.agenda) }
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${saals.sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'As usual we will have two weeks to complete all sprint 2 assignments',
			'As usual we will work on Discussion Board 1 as a scrum team in class on Thursday',
			'Different than sprint 1 in that we will have Demos and Retrospectives on Thursday',
			'Very different in that our second week of sprint 2 will be remote asynchronous** ' ])
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list, syllabus, and assignments together.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review sprint ${saals.sprint} activity list & assignments in detail`,
				'Discuss and identify questions/concerns',
				'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns',
				'How will you get your Scrum Team Discord server set up before class on Thursday?' ])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda) }

	return makeSlideDeck([ prework, announcements, agenda, sprintPlanningExpectations, activitiesReview, planningBreakout, tReviewDemoSchedule, preworkNext, recap ])
}

export const xyz_2_2of4 = (pAaA, pAaANext, saals, metricsSubmissionPercentage, retrospective ) => {
	const slideDeck = checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)

	const metrics = () => {
		return basicSlide(`Sprint ${saals.sprint-1} Metrics`, [
			`Let’s take a minute and review our Sprint ${saals.sprint-1} Submission Percentage class metric.` ])
	}

	const retrospectiveBreakout = () => {
		return orderedListSlide('Breakout Session for Team Retrospective', 
			'As a scrum team consider:', [
			`How does your team feel about sprint ${saals.sprint-1} now that it is over`,
			`What could be done to make sprint ${saals.sprint-1} or the class overall better or more manageable`,
			'What improvements should we make as a class, team, or individual going forward' ])
	}
	const sprintPlanningQA = () => {
		return orderedListSlide('Sprint Planning Q&A', 
			`Are you clear on what’s expected in sprint ${saals.sprint}?`, [])
	}
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const recap = () => { return tRecap(pAaA.agenda.slice(1))}

	return completeDeck(slideDeck, [ tReviewDemoSchedule, sprintDemosIntro, sprintDemos, demoAssignment, metrics, 
		metricsSubmissionPercentage, retrospective, retrospectiveBreakout, sprintPlanningQA, preworkNext, recap, tLab ])
}

export const xyz_1_3of4 = (pAaA, pAaANext, saals, breakoutSlide) => { 
	const poll = () => { return tPrework('Sprint Progress Polling', pAaA.prework, saals.sprint, saals.activityList) }
	const preworkNext = () => { return tPrework('Prework For Next Class', pAaANext.prework, saals.sprint, saals.activityList) }
	const quiz = () => { return tQuiz(saals.sprint) }
	const recap = () => { return tRecap(pAaA.agenda.slice(1)) }
	const slideDeck =  checklistAnnouncementsPreworkAndAgenda(pAaA, saals.sprint, saals.activityList)
	return completeDeck(slideDeck, [ poll, breakoutSlide, preworkNext, tLab, recap, tQuizExpectations, quiz ])
}
// End shared slides across multiple class sections.

// Session 1 of 4: Tuesday
export const se_2_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Upcoming Changes to the Course Structure',
		'Prework for Next Class' ]
}
const se_2_1of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:24, submitted:24 },
			{ name: 'Quiz', due:24, submitted:24 },
			{ name: 'Lab', due:24, submitted:23 },
			{ name: 'Reflection', due:24, submitted:23 }])
	} 
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Very good submission percentage in sprint ${sprint-1}`,
			'Some Lab and Reflection assignments not posted', 
			'Lots of nice comments about scrum teammates',
			'Be **sure** to put something in for each question so that I can give you at least a point or two',
			'What,no music suggestions or riddles in reflections?!?!',
			'Some difficulties with the thumbnail images', 
			`If you are not where you want to be in the class after sprint ${sprint-1}, let’s set up a time to talk.` ])
	}
	return xyz_2_1of4(se_2_1of4_PAaA, se_2_2of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective ) } 

// Session 2 of 4: Thursday
export const se_2_2of4_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		'Be prepared for Demos and Retrospectives',
		'Focus on “Engineering Software as a Service” Chapter 2',
		'Be prepared for “Engineering Software as a Service” Chapter 2 Breakout' ],
	'announcements':[
		'Any announcements?' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
}
const se_2_2of4 = () => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:20, submitted:19 },
			{ name: 'Quiz', due:20, submitted:20 },
			{ name: 'Lab', due:20, submitted:20 },
			{ name: 'Reflection', due:20, submitted:20 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Wonderful submission percentage in sprint ${sprint-1}... sooooo close!`,
			'Some Lab and Reflection assignments not posted', 
			'Be **sure** to put something in for each question so that I can give you at least a point or two',
			'What,no music suggestions or riddles in reflections?!?!' ])
	}
	
	return xyz_2_2of4(se_2_2of4_PAaA, se_2_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective) 
} 

// Session 3 of 4: Tuesday
const breakoutSaaSClientFrameworkJavaScriptName = 'SaaS Client Framework: JavaScript Introduction'
const breakoutSaaSClientFrameworkJavaScript = () => {
	return breakoutStandard( 
		`Breakout: ${breakoutSaaSClientFrameworkJavaScriptName}`, 
		`In this breakout session on ${breakoutSaaSClientFrameworkJavaScriptName} reading and lecture your team will discuss:`, [
		'** Your team’s yes, no, maybe response to Fall 2025 Capstone',
		'JavaScript and code running in the browser... How does this relate to Ruby/Rails?',
		'Author’s choice of SaaS tools and frameworks vs. our choice... how do you feel about that? (27:03)',
		'JavaScript and code running on the server plus Node.js, AJAX, JavaScript, and JSON', 
		'AJAX, REST, Web Services, and JSON', 
		'JavaScript libraries including JQuery, Bootstrap, Tailwind, REACT, and Vue',
		'REACT, static websites, Node.js, and MongoDB... Google Firebase' ])
}
export const se_2_3of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 11 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 2 and the associated lecture',
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		`All sprint ${sprint} activities and assignments due Sunday!` ],
	'agenda':[
		`Breakout: ${breakoutSaaSClientFrameworkJavaScriptName}`,
		'Review Azure Website',
		'Prework for Next Class',
		'Quiz 2' ]
}
const se_2_3of4 = () => { return xyz_1_3of4(se_2_3of4_PAaA, se_2_4of4_PAaA, sprintAndActivityLists, breakoutSaaSClientFrameworkJavaScript) }

// Session 4 of 4: Thursday

export const se_2_4of4_PAaA = {
	'prework':[
		'Complete through activity 14 prior to next class', 
		'Be prepared for Lab' ],
	'announcements':[
		`All sprint ${sprint} activities and assignments due Sunday!` ],
	'agenda':[
		`Final sprint ${sprint} activity list and assignment Q&A`,
		'Prework for Next Class', 
		'Lab']
}

const se_2_4of4 = () => { return xyz_n_4of4(sprint, activityList, se_2_4of4_PAaA, se_3_1of4_PAaA.prework ) }

// Sprint 3
// Session 1 of 4: Tuesday
export const se_3_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Review Course Structure',
		'Prework for Next Class' ]
}

export const se_2_slidedeckTTR = [ se_2_1of4, se_2_2of4, se_2_3of4, se_2_4of4 ] 